import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import LoadingPage from "../../../Components/layouts/loading";
import { labourTrainingInfo } from "../../../SchemaInfo/info";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import { Formik, Form, FieldArray } from "formik";
import CustomInput from "../../../CustomComponent/custom_input";
import CustomSelect from "../../../CustomComponent/custom_select";
import Footer from "../../../Components/Footer/footer";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { FcReadingEbook } from "react-icons/fc";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import CustomCheckbox from "../../../CustomComponent/custom_checkbox";
import { labourTrainingSchema } from "../../../Schemas/labour training/labourTraining";
import { getId } from "../../../Components/Functions/word.fun";

const EditLabourTraningSchedule = () => {
  let userData = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const [LabourTrainingInfo, setlabourTrainingInfo] =
    useState(labourTrainingInfo);
  const [project, setProjects] = useState([]);
  useEffect(() => {
    performRequest("GET", "/siteInspection/getAllProjects")
      .then((res) => setProjects(res.data))
      .catch((err) => CustomErrorResponse(err));
  }, [userData]);
  let { id } = useParams();
  const navigate = useNavigate();

  const [isHandOverCompleted, setIsHandOverCompleted] = useState(false);

  useEffect(() => {
    performRequest("GET", "/handOver/getHandOver/")
      .then((res) => {
        if (res.status === 200) {
          if (res?.data?.handOverData?.length > 0) {
            setIsHandOverCompleted(true);
          } else {
            setIsHandOverCompleted(false);
          }
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  const returnClassname = (status) => {
    if (status === "Day 1") {
      return "badge bg-lime  text-white";
    }
    if (status === "Day 2") {
      return "badge bg-purple  text-white";
    }
    if (status === "Day 3") {
      return "badge bg-azure  text-white";
    }
    if (status === "Day 4") {
      return "badge bg-pink  text-white";
    }
    if (status === "Day 4") {
      return "badge bg-green  text-white";
    }
    if (status === "Day 5") {
      return "badge bg-yellow  text-white";
    }
    if (status === "Day 6") {
      return "badge bg-cyan  text-white";
    }
    if (status === "Day 7") {
      return "badge bg-teal  text-white";
    }
    if (status === "Day 8") {
      return "badge bg-orange  text-white";
    }
  };
  const getBG = (date) => {
    let newDt = new Date().toISOString().split("T")[0];

    if (date == newDt) {
      return "bg-primary-lt";
    }
    return "";
  };
  const handleSubmit = (values, actions) => {
    if (userData?.Role === process.env.REACT_APP_ROLE_CLIENT) {
      let dt = project?.filter((el) => el.clientEmail === userData.Email);

      values = {
        ...values,
        clientProjectNumber: getId(dt[0]?.cpNumber),
      };
    }
    values = {
      ...values,
      clientProjectNumber: +values?.clientProjectNumber,
    };
    if (!values.clientProjectNumber) {
      Toast("error", "Client data not found!");
    } else {
      setLoading(true);
      performRequest(
        "PATCH",
        `/labourTraining/updateLabourTraining/${id}`,
        values
      )
        .then((res) => {
          if (res.status === 200) {
            Toast("success", "Crop update created successfully!");
            navigate(`/labour-training`);
          } else {
            Toast("error", "Error while creating water cycle");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }
  };

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/labourTraining/getlabourTraining/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setlabourTrainingInfo(res.data);
        } else {
          Toast("error", "Error while getting updates!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }

  // if (!isHandOverCompleted) {
  //   navigate("/labour-training/");
  // }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2>
                  <FcReadingEbook
                    className="fs-2 me-1"
                    style={{ color: "green" }}
                  />{" "}
                  Labour Training
                </h2>
                <h4 className="text-muted">
                  Track & manage your training progress.
                </h4>
              </div>
              <div className="col-md-4">
                <div className="btn-list justify-content-end">
                  <a href={"/labour-training/"} className="btn btn-primary">
                    <FcReadingEbook className="fs-3 me-2" />
                    ALL UPDATES
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="row col-12">
            <div className="card">
              <Formik
                initialValues={LabourTrainingInfo}
                validationSchema={labourTrainingSchema}
                onSubmit={handleSubmit}
              >
                {(props) => (
                  <Form>
                    <div className="card-body">
                      {userData?.Role !== process.env.REACT_APP_ROLE_CLIENT && (
                        <div className="mb-3 row">
                          <label className="w-25 form-label required col-3">
                            Client name
                          </label>
                          <div className="w-100 col">
                            <CustomSelect
                              type="text"
                              name="clientProjectNumber"
                            >
                              <option value="">Select</option>
                              {project?.map((cl) => (
                                <option key={cl.id} value={getId(cl.cpNumber)}>
                                  {cl.clientName}
                                </option>
                              ))}
                            </CustomSelect>
                            {props.touched.clientProjectNumber &&
                              props.errors.clientProjectNumber && (
                                <p className="text-danger">
                                  {props.errors.clientProjectNumber}
                                </p>
                              )}
                          </div>
                        </div>
                      )}
                      <div className="mb-3 row">
                        <label className="w-25 form-label required col-3">
                          Labour name
                        </label>
                        <div className="w-100 col">
                          <CustomInput name="labourName" type="text" />
                          {props.touched.labourName &&
                            props.errors.labourName && (
                              <p className="text-danger">
                                {props.errors.labourName}
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3 required">
                          Training start date
                        </label>
                        <div className="w-100 col">
                          <CustomInput
                            name="startDate"
                            type="date"
                            disabled={props.values?.labourSchedule?.length > 0}
                          />
                          {props.touched.startDate &&
                            props.errors.startDate && (
                              <p className="text-danger">
                                {props.errors.startDate}
                              </p>
                            )}
                        </div>
                      </div>

                      <FieldArray name="labourSchedule">
                        {({ push, remove }) => (
                          <div>
                            {props.values?.labourSchedule?.length > 0 && (
                              <table className="fs-5 table table-vcenter ">
                                <thead>
                                  <tr>
                                    <th>Day / Date</th>
                                    <th>Activity</th>
                                    <th>mark Done</th>
                                    <th>schedule Done date</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {props.values?.labourSchedule?.map(
                                    (schedule, index) => {
                                      return (
                                        <tr
                                          key={index}
                                          className={getBG(schedule?.date)}
                                        >
                                          <td>
                                            <span>{schedule.day}</span>
                                            <br />
                                            <span>{schedule.date}</span>
                                          </td>
                                          <td>
                                            <span
                                              className={returnClassname(
                                                schedule.day
                                              )}
                                            >
                                              {schedule.work}
                                            </span>
                                            <br />
                                            <span>
                                              {schedule.activity || "N/A"}
                                            </span>
                                          </td>
                                          <td>
                                            <CustomCheckbox
                                              type="checkbox"
                                              width={"23px"}
                                              height={"23px"}
                                              name={`labourSchedule[${index}].activityDone`}
                                              onChange={(e) => {
                                                props.setFieldValue(
                                                  `labourSchedule[${index}].activityDone`,
                                                  !schedule.activityDone
                                                );
                                                let date = new Date();
                                                props.setFieldValue(
                                                  `labourSchedule[${index}].activityDoneDate`,
                                                  !schedule.activityDone
                                                    ? date
                                                        .toISOString()
                                                        .split("T")[0]
                                                    : ""
                                                );
                                              }}
                                            ></CustomCheckbox>
                                          </td>
                                          <td>
                                            {schedule.activityDoneDate || "---"}
                                          </td>
                                          <td></td>
                                        </tr>
                                      );
                                    }
                                  )}
                                </tbody>
                              </table>
                            )}
                          </div>
                        )}
                      </FieldArray>
                    </div>
                    <div className="card-footer">
                      <div className="btn-list justify-content-end">
                        <FormSubmitButton buttonText="Update  schedule" />
                        <SimpleButton buttonText="Cancel" type="secondary" />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default EditLabourTraningSchedule;
